module.exports = __webpack_public_path__ + "img/background-difuminado.b913c8c4.jpg";